import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-prog',
  imports: [],
  templateUrl: './investment-prog.component.html',
  styleUrl: './investment-prog.component.css',
})
export class InvestmentProgComponent {

}
